<template>
  <div>
    <el-table class="currentTable" size="mini" :data="sub" :header-cell-style="{ color: 'black', 'font-weight': 'bold', height: '48px', padding: '0px', 'font-size': '14px' }">
      <el-table-column :label="$t('paixu')" :width="50">
        <template #default="scope">
          {{ scope.row.serialNo }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('chanpinbianma')" :width="130">
        <template #default="scope">
          {{ scope.row.material.code }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('chanpinmingcheng')" :width="180">
        <template #default="scope">
          {{ scope.row.material.name }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('sehao')" :width="180" v-if="colorNoEnable">
        <template #default="scope">
          {{ $t(store.state.dictJsonAll['CUSTOMER_MATERIAL_COLOR_NO'][scope.row.colorNo]) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('guige')" :width="130">
        <template #default="scope">
          {{ scope.row.material.spec }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('xiaoshoudanwei')" :width="100">
        <template #default="scope">
          <span>{{ $t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.saleUnit]) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('xiaoshoushuliang')" :width="130">
        <template #default="scope">
          {{ scope.row.saleQuantity }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('danweihuozhi')" :width="130">
        <template #default="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('hejizhi')" :width="150">
        <template #default="scope">
          {{ (scope.row.saleQuantity * scope.row.price).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('yaohuoriqi')" :width="160">
        <template #default="scope">
          {{ scope.row.requestDate ? dayjs.unix(scope.row.requestDate / 1000).format('YYYY-MM-DD') : "" }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('zhuangtai')" :width="100">
        <template #default="scope">
          <span v-if="scope.row.status !== null" :style="{ color: status[scope.row.status].color, 'border-color': status[scope.row.status].color, background: status[scope.row.status].tagBg }"
                style="border-radius: 2px;font-size: 14px;padding: 3px 8px;box-sizing: border-box;border: none;">
            {{ status[scope.row.status].title }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    sub: {
      type: Array,
      default: () => []
    },
    all: {
      type: Array,
      default: () => []
    },
    // 生产配置-产品色号管理
    colorNoEnable: {
      type: Boolean,
      default: false
    }
  },
  name: 'web_sale_order_management_sale_order_sub_list',
  data() {
    return {
      status: {
        '0': {
          color: '#419FFF',
          title: this.$t('xinjian'),
          tagBg: '#ECF5FF'
        },
        '1': {
          color: '#36CFC9',
          title: this.$t('bufenfahuo'),
          tagBg: '#E6FFFB'
        },
        '2': {
          color: '#597EF7',
          title: this.$t('yifahuo'),
          tagBg: '#F0F5FF'
        },
        '3': {
          color: '#67C23A',
          title: this.$t('yiwancheng'),
          tagBg: '#F0F9EB'
        },
      }
    };
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.currentTable /deep/ th {
  border: 0 !important;
}

.currentTable /deep/ .el-table__body .el-table__row td {
  border: 0 !important;
}

.currentTable /deep/ .el-table--border td,
.el-table--border th {
  /* Optional: Remove table borders or apply custom styles */
}
</style>
